var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content.type.split('_')[0] === 'title')?_c('title-content',{attrs:{"content":_vm.content}}):_c('regular-content',{attrs:{"content":_vm.content,"actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }